import { render, staticRenderFns } from "./Publications.vue?vue&type=template&id=73ea4ee5&scoped=true"
var script = {}
import style0 from "./Publications.vue?vue&type=style&index=0&id=73ea4ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ea4ee5",
  null
  
)

export default component.exports